import { render } from "./Reports.vue?vue&type=template&id=132c0227&scoped=true&ts=true"
import script from "./Reports.vue?vue&type=script&lang=ts"
export * from "./Reports.vue?vue&type=script&lang=ts"

import "./Reports.vue?vue&type=style&index=0&id=132c0227&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/on-the-edge-admin/on-the-edge-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-132c0227"]])

export default __exports__